import { ROUTE } from "../../../routes";
export const updateAmount = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => {
    navigate(ROUTE.MODIFY_PLEDGED_AMOUNT);
    console.warn("****Amount data****");
    // await setDatastore(action.routeId, action.payload.widgetId, <ButtonProps>{
    //   loading: true,
    // });
};
export const goBack = async (action, _datastore, { navigate, setDatastore, asyncStorage, goBack }) => {
    goBack();
};
